<template>
  <div class="rf-field rf-text" :class="computedClass">

    <!-- Slot for custom label markup -->
    <slot>
      <label :for="name" class="rf-label">{{ label }}</label>
    </slot>

    <!-- Note about dynamic type: https://github.com/vuejs/vue/issues/3915 -->
    <!-- The above applies to radio/checkbox, but seems to be working in this case... -->
    <div class="rf-input">
      <input
        v-bind="{ type, name, id: name, disabled, placeholder }"
        @blur="onBlur"
        v-model="value"
        v-mask="computedMask"
        v-validate="computedValidation"
        ref="input"
      >
      <transition name="fade-fast">
        <icon name="exclamation-triangle" class="rf-icon rf-icon-invalid" v-if="showInvalid" key="invalid"></icon>
        <icon name="check" class="rf-icon rf-icon-valid" v-else-if="showValid" key="valid"></icon>
      </transition>
      <!-- Errors -->
      <rf-message v-if="showInvalid">{{ errors.first(name) }}</rf-message>
    </div>

  </div>
</template>

<script>
import mixins from '@/mixins/index'
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'RfText',
  mixins: mixins,
  props: {
    type: {
      type: String,
      default: 'text'
    },
    initialValue: {
      type: String,
      default: null
    },
    mask: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedMask () {
      return this.type === 'tel' && !this.mask ? '(###) ###-####' : this.mask
    },
    computedValidation () {
      if (this.type === 'tel') {
        if (typeof this.validation === 'string') {
          return {
            required: true,
            regex: /^\(\d{3}\)\s\d{3}-\d{4}$/
          }
        } else {
          return this.validation
        }
      }

      return this.validation
    }
  },
  created () {
    this.componentType = 'rf-text'
  },
  mounted () {
    // Set initial value and validate
    if (this.initialValue) {
      this.value = this.initialValue
      this.$validator.validate(this.name, this.value)
    }
  },
  methods: {
    isInActiveSection () {
      return typeof this.parentSection === 'undefined' ? true : this.parentSection.isActive
    },
    onBlur () {
      // We may be blurring because of a section-nav event, in which case we don't want to validate if this field is no longer in the active section
      // We might also be blurring because of a call to clearValidation()
      this.isDirty = this.isInActiveSection() && (this.fields[this.name].dirty || Boolean(this.initialValue))
      if (this.isDirty) {
        this.validate()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RfText.vue?400bba32